"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionFromNullable = void 0;
/**
 * @since 0.5.0
 */
var Either_1 = require("fp-ts/lib/Either");
var Option_1 = require("fp-ts/lib/Option");
var t = require("io-ts");
var option_1 = require("./option");
/**
 * @since 0.5.0
 */
function optionFromNullable(codec, name) {
    if (name === void 0) { name = "Option<" + codec.name + ">"; }
    return new t.Type(name, option_1.option(codec).is, function (u, c) { return (u == null ? t.success(Option_1.none) : Either_1.either.map(codec.validate(u, c), Option_1.some)); }, function (a) { return Option_1.toNullable(Option_1.option.map(a, codec.encode)); });
}
exports.optionFromNullable = optionFromNullable;
